/**
 * Per-service configuration. Key = serviceKey from backend (e.g. CHARGE_ELECTRICITY).
 * - alert: optional message shown at top of modal (explains costs, process, etc.)
 * - Simple: { alert?, fields: [...] }
 * - Conditional: { alert?, selector: { key, label, options }, fieldSets: { [selectorValue]: [fields] } }
 */
export const SERVICE_FIELD_CONFIG = {
  CHARGE_ELECTRICITY: {
    selector: {
      key: 'meterType',
      label: 'نوع العدّاد',
      defaultValue: 'token',
      options: [
        { value: 'token', label: 'رقم' },
        { value: 'card', label: 'كرت' },
      ],
    },
    fieldSets: {
      token: [
        { key: 'meterNumber', label: 'رقم الحساب', placeholder: 'أدخل رقم حساب العدّاد', required: true },
      ],
      card: [
        { key: 'address', label: 'عنوان التوصيل', placeholder: 'اسم الشارع، رقم العمارة...', required: true },
      ],
    },
  },
  CHARGE_WATER: {
    fields: [
      { key: 'meterNumber', label: 'رقم العدّاد', placeholder: 'أدخل رقم حساب العدّاد', required: true },
      { key: 'address', label: 'العنوان', placeholder: 'اسم الشارع، رقم العمارة...', required: true },
    ],
  },
  GAS_CYLINDER: {
    alert: ' هذه الخدمة مجّانيّة، اطلب وسنقوم بتوصيلها لك بنفس سعرها بالسوق (يرجى العلم بأن الغاز في حالة عدم استقرار حاليا وقد يكون غير متاح)',
    fields: [
      { key: 'quantity', label: 'عدد الجرار', placeholder: 'كم جرّة؟', required: true },
      { key: 'address', label: 'العنوان', placeholder: 'اسم الشارع، رقم العمارة...', required: true },
    ],
  },
  ORDER_TAXI: {
    alert: 'هذه الخدمة مجّانيّة، اطلب تاكسي وسنقوم بالبحث عن تكسي متاح وارساله لك بأقرب وقت ممكن وبدون رسوم اضافية',
    fields: [
      { key: 'pickupAddress', label: 'عنوان الانطلاق', placeholder: 'من أين؟', required: true },
      { key: 'destinationAddress', label: 'عنوان الوصول', placeholder: 'إلى أين؟', required: true },
    ],
  },
}

/** Optional background color per service key for card styling */
export const SERVICE_COLORS = {
  GAS_CYLINDER: '#fdf2e9',
  CHARGE_ELECTRICITY: '#fef9e7',
  CHARGE_WATER: '#ebf5fb',
  ORDER_TAXI: '#fff8e1',
}

/** Emoji per service key (customizable in FE) */
export const SERVICE_EMOJI = {
  GAS_CYLINDER: '🔥',
  CHARGE_ELECTRICITY: '⚡',
  CHARGE_WATER: '💧',
  ORDER_TAXI: '🚕',
}
